import {
  Box,
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { UpdateFinStatementLineItemInputGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  onDelete: () => Promise<void>;
  lineItemEdits: UpdateFinStatementLineItemInputGQLType;
  setLineItemEdits: React.Dispatch<
    React.SetStateAction<UpdateFinStatementLineItemInputGQLType | null>
  >;
};

export const EditFinStatementLineItemModal = ({
  isOpen,
  onConfirm,
  onCancel,
  lineItemEdits,
  setLineItemEdits,
  onDelete,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onCancel();
      }}
      size="lg"
    >
      <ModalOverlay />
      <ModalContent p="5">
        <ModalHeader>Edit Line Item</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <Box>
            <Flex alignItems="center" mb="6">
              <Text mr="6px">Ledger Name:</Text>
              <Input
                ml="auto"
                width="300px"
                placeholder={lineItemEdits.props.ledgerName ?? ''}
                value={lineItemEdits.props.ledgerName ?? ''}
                onChange={(e) => {
                  setLineItemEdits((state) => {
                    if (!state) {
                      return state;
                    }

                    return {
                      ...state,
                      props: {
                        ...state.props,
                        ledgerName: e.target.value,
                      },
                    };
                  });
                }}
              />
            </Flex>
            <Flex alignItems="center" mb="6">
              <Text mr="6px">Value:</Text>
              <Input
                ml="auto"
                type="number"
                width="300px"
                placeholder={String(lineItemEdits.props.value ?? 0)}
                value={String(lineItemEdits.props.value ?? 0)}
                onChange={(e) => {
                  setLineItemEdits((state) => {
                    if (!state) {
                      return state;
                    }

                    return {
                      ...state,
                      props: { ...state.props, value: Number(e.target.value) },
                    };
                  });
                }}
              />
            </Flex>
            <Flex justifyContent="flex-end">
              <Button
                type="button"
                mr="5"
                onClick={async () => {
                  await onConfirm();
                  onCancel();
                }}
              >
                Confirm
              </Button>
              <Button
                type="button"
                mr="5"
                onClick={async () => {
                  await onDelete();
                  onCancel();
                }}
              >
                Delete
              </Button>
              <Button onClick={() => onCancel()}>Cancel</Button>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
